import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
import { Button, IconButton, Modal, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Grid, Typography, Divider, } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { CATEGORY_API_URL, ORDER_API_URL } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider'
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import { useNavigate } from "react-router";
import LocationIcon from "@mui/icons-material/LocationOn";

const PlacedOrder = () => {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdAt');
    const axiosPrivate = useAxiosPrivate();
    const [openModal, setOpenModal] = useState(false);
    const [modelTitle, setmodelTitle] = useState("");
    const [filterName, setFilterName] = useState('');

    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loding, setLoding] = useState(true);
    const [orderDetailData, setOrderDetailData] = useState([]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const permissionsData = useStore(state => state.permissions);
    const navigate = useNavigate();

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'user_data.firstname', label: 'User Name', alignRight: false },
        { id: 'user_data.email', label: 'Email/Mobile', alignRight: false },
        { id: 'vendor_data.businessName', label: 'Business Name', alignRight: false },
        { id: 'vendor_data.category_type', label: 'Order Type', alignRight: false },
        { id: 'order_id', label: 'Order Id', alignRight: false },
        { id: 'total_amount', label: 'Amount', alignRight: false },
        { id: 'createdAt', label: 'Order Date', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        { id: 'action', label: 'Action', alignRight: false },
    ];
    async function getOrder(page, filterName) {
        const response = await axiosPrivate.get(ORDER_API_URL.placedOrder, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: orderList, refetch } = useQuery(['orderList', page, filterName], () => getOrder(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (orderList) {
            setTableData(orderList.data);
            setRowsPerPage(orderList?.metadata.length != 0 ? orderList?.metadata[0].limit : 10);
        }
        if (orderList?.metadata.length != 0 && orderList?.metadata[0].hasMoreData == true) {
            getOrder(page + 1);
        }
        setLoding(false);
    }, [orderList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getOrder(page, filterName)
        refetch();
    };


    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

    const filteredOrders = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
    };

    const deleteFoodItem = async () => {
        const response = await axiosPrivate.delete(CATEGORY_API_URL.deleteFood + deleteId)
        if (response.status == 200) {
            enqueueSnackbar("food item delete successfully", {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        } else {
            enqueueSnackbar("something went wrong", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch();
        handleClose();
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleViewDetail = (orderDetails) => {
        setOpenModal(true);
        setOrderDetailData(orderDetails)
        setmodelTitle('Order Details')
    }

    return (
        <>
            {loding ? <LoadingScreen /> : <>
                <div className="dashboard_header mb-4">
                    <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Placed Orders</h4>
                    <Paper component="form" className='dashboard_searchbox col-lg-4'>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="search ..."
                            onChange={(e) => handleFilterByName(e)}
                        />
                    </Paper>
                </div>

                <Card>
                    <TableContainer>
                        <Table>
                            <UserListHead
                                headLabel={TABLE_HEAD}
                                rowCount={orderList?.data?.length}
                                onRequestSort={handleRequestSort}
                            />
                            {filteredOrders?.length > 0 ?
                                <TableBody>
                                    {filteredOrders.map((row) => {
                                        return (
                                            <StyledTableRow key={row._id}>
                                                <TableCell component="th" scope="row">
                                                    {row?.user_data?.firstname}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row?.user_data?.email || row?.user_data?.mobile}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row?.vendor_data?.businessName}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row?.vendor_data?.category_type == "1" ? "Restaurant" : "Grocery"}
                                                </TableCell>
                                                <TableCell align="left"> {row?.order_id} </TableCell>
                                                <TableCell align="left"> {row?.total_amount} </TableCell>
                                                <TableCell align="left"> {moment(row.createdAt).format("MMM DD YYYY h:mm A")}</TableCell>

                                                <TableCell>
                                                    <Stack direction="row" spacing={3}>
                                                        {
                                                            row.status == 0 ? <Chip variant="contained" label="Pending" className="app_status_chip pending" onClick="" /> : row.status == 1 ? <Chip variant="contained" className="app_status_chip in_progress" label="In Progress" /> : row.status == 2 ? <Chip variant="contained" className="app_status_chip completed" label="Completed" /> : <Chip variant="contained" className="app_status_chip canclled" label="Canclled" />
                                                        }
                                                    </Stack>
                                                </TableCell>
                                                <TableCell>
                                                    <Stack direction="row" spacing={1}>
                                                        <Button title="Order Details" variant="text" className="user_list_row_btn" onClick={(e) => handleViewDetail(row)} ><VisibilityIcon /></Button>

                                                    </Stack>
                                                </TableCell>
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                                :
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                            <span className="app_text_16_semibold">No Data Found</span>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        count={orderList?.metadata.length != 0 ? orderList?.metadata[0].total : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
                <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="child-modal-title"
                    aria-describedby="child-modal-description"
                >
                    <DialogTitle
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px solid #c6c6c6",
                        }}
                    >
                        <div className="left_part">
                            <h4>{modelTitle}</h4>
                        </div>
                        <div className="right_part">
                            <Button
                                className="dashboard_light_bg_icon_btn"
                                onClick={handleCloseModal}
                                aria-label="delete"
                            >
                                <CloseIcon style={{ color: "#fff" }} />
                            </Button>
                        </div>
                    </DialogTitle>
                    <DialogContent className="custom_form_mui">
                        <Grid container spacing={2} sx={{ py: 2 }}>
                            <Grid item xs={12}>
                                <Typography className="app_text_16_semibold">
                                    {orderDetailData?.vendor_data?.businessName || null}
                                </Typography>
                                <Stack spacing={1} direction="row" alignItems={"center"}>
                                    <LocationIcon
                                        style={{ marginLeft: "-5px", color: "#A6A6A6" }}
                                    />
                                    <p className="app_text_14_500 app_text_gray">
                                        {orderDetailData?.vendor_data?.businessAddress || null}
                                    </p>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider
                                    sx={{
                                        borderColor: "#A6A6A6",
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    display={"flex"}
                                    justifyContent={"space-between"}
                                    alignItems="center"
                                >
                                    <Box>
                                        <Typography className="app_text_16_semibold">
                                            Order
                                        </Typography>
                                    </Box>
                                    <Box>
                                        {orderDetailData?.status === 0 && (
                                            <Chip
                                                label="Pending"
                                                style={{ backgroundColor: "#E4A11B", color: "#fff" }}
                                            />
                                        )}
                                        {orderDetailData?.status === 1 && (
                                            <Chip
                                                label="In Progress"
                                                style={{ backgroundColor: "#54B4D3", color: "#fff" }}
                                            />
                                        )}
                                        {orderDetailData?.status === 2 && (
                                            <Chip
                                                label="Completed"
                                                style={{ backgroundColor: "#14A44D", color: "#fff" }}
                                            />
                                        )}
                                        {orderDetailData?.status === 3 && (
                                            <Chip
                                                label="Cancelled"
                                                style={{ backgroundColor: "#DC4C64", color: "#fff" }}
                                            />
                                        )}
                                    </Box>
                                </Box>
                                {orderDetailData?.items ? (
                                    <Box marginTop={2} boxShadow={"0px 1px 3px #A6A6A6"}>
                                        <Table>
                                            {orderDetailData?.items.map((row) => {
                                                return (
                                                    <StyledTableRow key={row._id}>
                                                        <TableCell>
                                                            {row.item_name ? (
                                                                <Stack
                                                                    display={"flex"}
                                                                    alignItems="flex-start"
                                                                    spacing={3}
                                                                    direction={"row"}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            height: "80px",
                                                                            width: "80px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            borderRadius: "12px",
                                                                            overflow: "hidden",
                                                                        }}
                                                                    >

                                                                        {orderDetailData?.vendor_data?.category_type == "1" ?
                                                                            <img
                                                                                src={
                                                                                    row?.image
                                                                                        ? process.env.REACT_APP_PROFILE_URL +
                                                                                        "foodItem/" +
                                                                                        row?.image
                                                                                        : ""
                                                                                }
                                                                                alt=""
                                                                                style={{
                                                                                    height: "100%",
                                                                                    width: "100%",
                                                                                    objectFit: "cover",
                                                                                    objectPosition: "center",
                                                                                }}
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={
                                                                                    row?.image
                                                                                        ? process.env.REACT_APP_PROFILE_URL +
                                                                                        "groceryItem/" +
                                                                                        row?.image
                                                                                        : ""
                                                                                }
                                                                                alt=""
                                                                                style={{
                                                                                    height: "100%",
                                                                                    width: "100%",
                                                                                    objectFit: "cover",
                                                                                    objectPosition: "center",
                                                                                }}
                                                                            />
                                                                        }
                                                                    </Box>
                                                                    <Box>
                                                                        <h6>{row?.item_name}</h6>
                                                                        <p>{row?.quantity + "x"}</p>
                                                                    </Box>
                                                                </Stack>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </TableCell>

                                                        <TableCell
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "right",
                                                            }}
                                                        >
                                                            <Typography className="app_text_14_semibold">
                                                                £{row?.total}
                                                            </Typography>
                                                        </TableCell>
                                                    </StyledTableRow>
                                                );
                                            })}
                                        </Table>
                                    </Box>
                                ) : (
                                    ""
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className="app_text_16_semibold">
                                    Order Details
                                </Typography>
                                <Box
                                    sx={{
                                        border: "1px solid gainsboro",
                                        padding: "16px",
                                        marginTop: 4,
                                    }}
                                >
                                    <Stack spacing={2}>
                                        <Box>
                                            <Typography className="app_text_14_semibold">
                                                Order Number
                                            </Typography>
                                            <Typography className="app_text_12_fw500 app_text_gray">
                                                {orderDetailData?.order_id}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography className="app_text_14_semibold">
                                                Payment Type
                                            </Typography>
                                            <Typography className="app_text_12_fw500 app_text_gray">
                                                {orderDetailData?.payment_type}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography className="app_text_14_semibold">
                                                Date
                                            </Typography>
                                            <Typography className="app_text_12_fw500 app_text_gray">
                                                {moment(orderDetailData?.createdAt).format("DD MMM YYYY")}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography className="app_text_14_semibold">
                                                {orderDetailData?.mobile ? "Phone Number" : "Email"}
                                            </Typography>
                                            <Typography className="app_text_12_fw500 app_text_gray">
                                                {orderDetailData?.user_data?.mobile
                                                    ? orderDetailData?.user_data?.mobile
                                                    : orderDetailData?.user_data?.email}
                                            </Typography>
                                        </Box>
                                        {orderDetailData?.is_pickup == true ? "" :
                                            <Box>
                                                <Typography className="app_text_14_semibold">
                                                    Deliver to
                                                </Typography>
                                                <Typography className="app_text_12_fw500 app_text_gray">
                                                    {orderDetailData?.delivery_address}
                                                </Typography>
                                            </Box>
                                        }

                                    </Stack>
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className="app_text_16_semibold">
                                    Bill Details
                                </Typography>
                                <Box
                                    sx={{
                                        border: "1px solid gainsboro",
                                        // padding: "16px",
                                        marginTop: 4,
                                    }}
                                >
                                    <Table>
                                        <StyledTableRow>
                                            <TableCell>
                                                <Typography className="app_text_14_semibold">
                                                    Item Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography className="app_text_14_semibold">
                                                    £{orderDetailData?.sub_total}
                                                </Typography>
                                            </TableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <TableCell>
                                                <Typography className="app_text_14_semibold">
                                                    Tax
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography className="app_text_14_semibold">
                                                    £{orderDetailData?.tax}
                                                </Typography>
                                            </TableCell>
                                        </StyledTableRow>
                                        {orderDetailData?.is_pickup == true ? "" :
                                            <StyledTableRow>
                                                <TableCell>
                                                    <Typography className="app_text_14_semibold">
                                                        Delivery Charge
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography className="app_text_14_semibold">
                                                        £{orderDetailData?.delivery_charge}
                                                    </Typography>
                                                </TableCell>
                                            </StyledTableRow>
                                        }
                                        <TableRow>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell style={{ borderBottom: "0" }}>
                                                <Typography className="app_text_14_semibold">
                                                    Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" style={{ borderBottom: "0" }}>
                                                <Typography className="app_text_14_semibold">
                                                    £{orderDetailData?.total_amount}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
            }
        </>
    )
}

export default PlacedOrder